import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { icons, Button, Icon } from '../ui-blocks'
import { Table } from '../specialized-components'

import { objectListRenderer, tableActionsRenderer } from '..'


const tableColumns = [
  {
    field: 'title', title: 'Name',
    renderer: row =>
      <Link to={`/topics/${row.id}`} className="link-dark underline-on-hover py-2">
        <strong>{row.title}</strong>
      </Link>
  },
  {
    field: 'courses', title: 'Assigned Courses',
    renderer: objectListRenderer('title')
  }
]


export const Topics = ({ topics, deleteAction }) => (
  <>
    {!!topics.length ? (
      <>

        <div className="list-actions">
          <Link to="/topics/0">
            <Button><Icon icon={icons.add} />New topic</Button>
          </Link>
        </div>

        <div className="paper">
          <Table
            columns={tableColumns}
            rows={topics}
            actionsRenderer={tableActionsRenderer({
              view: row => row.link,
              edit: row => `/topics/${row.id}`,
              delete: deleteAction
            })}
          />
        </div>

      </>
    ) : (
        <div className="text-center mt-5">

          <Icon icon={icons.topics} className="display-1 mb-4" />

          <h3 className="mb-4">
            Create your first topic
          </h3>

          <Link to="/topics/0">
            <Button><Icon icon={icons.add} />New topic</Button>
          </Link>

        </div>
      )
    }
  </>
)

Topics.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.object).isRequired,
  deleteAction: PropTypes.func.isRequired
}
